import React, { useState, useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { useToasts } from 'react-toast-notifications';
import * as ROUTES from '../../../constants/routes';
import { blogService } from '../../../services/blogService';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

export default function BlogEdit() {
  const { id } = useParams();
  const history = useHistory();
  const { addToast } = useToasts();
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [formData, setFormData] = useState({
    title: '',
    content: '',
    excerpt: '',
  });

  useEffect(() => {
    let isMounted = true;

    const fetchPost = async () => {
      try {
        const post = await blogService.getPostById(id);
        if (!isMounted) {
          return;
        }
        if (post) {
          setFormData({
            title: post.title || '',
            content: post.content || '',
            excerpt: post.excerpt || '',
          });
        } else {
          addToast('Blog post not found.', {
            appearance: 'error',
            autoDismiss: true,
          });
          history.push(ROUTES.ADMIN_BLOG);
        }
      } catch (error) {
        if (isMounted) {
          addToast('An error occurred while loading the blog post.', {
            appearance: 'error',
            autoDismiss: true,
          });
          history.push(ROUTES.ADMIN_BLOG);
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    fetchPost();

    return () => {
      isMounted = false;
    };
  }, [id, addToast, history]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleQuillChange = (value) => {
    setFormData(prev => ({
      ...prev,
      content: value
    }));
  };

  const handleSummaryQuillChange = (value) => {
    setFormData(prev => ({
      ...prev,
      excerpt: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);

    try {
      await blogService.updatePost(id, formData);
      addToast('Blog post updated successfully.', {
        appearance: 'success',
        autoDismiss: true,
      });
      history.push(ROUTES.ADMIN_BLOG);
    } catch (error) {
      addToast('Blog yazısı güncellenirken bir hata oluştu.', {
        appearance: 'error',
        autoDismiss: true,
      });
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <div className="container text-center">
        <div className="spinner-border" role="status">
          <span className="sr-only">Loading...</span>
        </div>
      </div>
    );
  }

  return (
    <div className="container">
      <div className="row mb-4">
        <div className="col">
          <h2>Edit Blog Post</h2>
        </div>
      </div>

      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="title">Title</label>
          <input
            type="text"
            className="form-control"
            id="title"
            name="title"
            value={formData.title}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="excerpt">Summary</label>
          <ReactQuill
            value={formData.excerpt}
            onChange={handleSummaryQuillChange}
            theme="snow"
            id="excerpt"
          />
        </div>

        <div className="form-group">
          <label htmlFor="content">Content</label>
          <ReactQuill
            value={formData.content}
            onChange={handleQuillChange}
            theme="snow"
            id="content"
          />
        </div>

        <div className="form-group">
          <button
            type="submit"
            className="btn btn-primary"
            disabled={saving}
          >
            {saving ? (
              <>
                <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true" />
                Saving...
              </>
            ) : (
              'Save'
            )}
          </button>
          <button
            type="button"
            className="btn btn-secondary ml-2"
            onClick={() => history.push(ROUTES.ADMIN_BLOG)}
            disabled={saving}
          >
            Cancel
          </button>
        </div>
      </form>
    </div>
  );
} 